module.exports = __webpack_public_path__ + "6d2d6c8291f61a26e2936ff7ad03cff5.pdf";